// Routes
export const ROUTES = {
  HOME: '/',
  CATALOG: '/catalogo',
  ORDER: '/pedido',
  CLIENTS: '/clientes',
  PRICING: '/precios',
  CONTACT: '/contacto',
};

// Types
export interface Product {
  id: string;
  name: string;
  category: string;
  description: string;
  features: string[];
  styles: string[];
  image?: string;
  tag?: string;
}

export interface OrderForm {
  // Datos del cliente
  clientName: string;
  phone: string;
  email: string;
  city: string;
  state: string;
  // Datos del pedido
  sport: string;
  teamName: string;
  quantity: number;
  shirtStyle: string;
  // Personalización
  colors: string;
  hasLogo: string;
  logoDescription: string;
  hasNumbers: string;
  hasNames: string;
  // Tallas
  sizes: string;
  // Referencia
  referenceDescription: string;
  deliveryDate: string;
  additionalNotes: string;
}

export interface ClientPhoto {
  id: string;
  clientName: string;
  sport: string;
  teamName: string;
  imageSrc: string;
  description: string;
}

// Products Data
export const PRODUCTS: Product[] = [
  {
    id: 'playera-mc',
    name: 'PLAYERA MANGA CORTA',
    category: 'Deportivo',
    description: 'Diseñada para el máximo rendimiento. Tela microperforada ultra transpirable con tecnología full print.',
    features: ['Microperforada', 'Secado rápido', 'Elástica 4 vías', 'Ligera', 'UV Protection'],
    styles: ['Cuello Redondo', 'Cuello V'],
    tag: 'MÁS VENDIDA',
  },
  {
    id: 'playera-sl',
    name: 'PLAYERA SIN MANGAS',
    category: 'Deportivo',
    description: 'Libertad total de movimiento. Perfecta para atletismo, crossfit y entrenamientos intensos.',
    features: ['Microperforada', 'Secado rápido', 'Elástica 4 vías', 'Transpirable'],
    styles: ['Sin mangas', 'Con tirantes'],
  },
  {
    id: 'playera-ml',
    name: 'PLAYERA MANGA LARGA',
    category: 'Pesca / Outdoor',
    description: 'Protección UV completa. Ideal para pesca, ciclismo y actividades al aire libre bajo el sol.',
    features: ['Protección UV', 'Microperforada', 'Secado rápido', 'Ligera'],
    styles: ['Manga Larga Pesca'],
  },
  {
    id: 'polo',
    name: 'POLO EMPRESARIAL',
    category: 'Profesional',
    description: 'Elegante y funcional. Perfecta para uniformes empresariales y eventos con tu marca.',
    features: ['Microperforada', 'Elástica 4 vías', 'Full print', 'Premium'],
    styles: ['Tipo Polo'],
    tag: 'NUEVA',
  },
];

export const SPORTS = [
  'Fútbol', 'Basketball', 'Vóley', 'Atletismo', 'Ciclismo',
  'Béisbol', 'Fútbol Americano', 'Pádel', 'Pesca', 'CrossFit',
  'Trabajo / Empresa', 'Otro',
];

export const SHIRT_STYLES = [
  'Manga corta cuello redondo',
  'Manga corta cuello V',
  'Sin mangas',
  'Con tirantes',
  'Manga larga tipo pesca',
  'Tipo Polo',
];

export const PRICING = [
  { label: 'PRECIO UNITARIO', quantity: '1 pieza', price: '$350', highlight: false },
  { label: 'MENOS DE 20', quantity: '2–19 piezas', price: '$290', highlight: false },
  { label: '20 A 99 PIEZAS', quantity: '20–99 piezas', price: '$260', highlight: true },
  { label: '100 A 399 PIEZAS', quantity: '100–399 piezas', price: '$240', highlight: false },
  { label: '400+ PIEZAS', quantity: '400 piezas o más', price: 'CONSULTA', highlight: false },
];

export const CLIENT_PHOTOS: ClientPhoto[] = [
  {
    id: '1',
    clientName: 'Equipo Tigres FC',
    sport: 'Fútbol',
    teamName: 'Tigres FC',
    imageSrc: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=600&q=80',
    description: 'Uniformes completos para toda la temporada',
  },
  {
    id: '2',
    clientName: 'Academia Baloncesto Norte',
    sport: 'Basketball',
    teamName: 'Academia Norte',
    imageSrc: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=600&q=80',
    description: 'Jersey y short para equipo completo',
  },
  {
    id: '3',
    clientName: 'Team Runners MTY',
    sport: 'Atletismo',
    teamName: 'Runners MTY',
    imageSrc: 'https://images.unsplash.com/photo-1513593771513-7b58b6c4af38?w=600&q=80',
    description: 'Playeras para carrera 10K',
  },
  {
    id: '4',
    clientName: 'Empresa Constructora XYZ',
    sport: 'Trabajo / Empresa',
    teamName: 'Constructora XYZ',
    imageSrc: 'https://images.unsplash.com/photo-1565073182887-6bcefbe225b1?w=600&q=80',
    description: 'Uniformes corporativos tipo polo',
  },
  {
    id: '5',
    clientName: 'Vóley Club Campeón',
    sport: 'Vóley',
    teamName: 'Club Campeón',
    imageSrc: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=600&q=80',
    description: 'Uniformes para torneo regional',
  },
  {
    id: '6',
    clientName: 'Ciclismo Extremo',
    sport: 'Ciclismo',
    teamName: 'Ciclismo Extremo',
    imageSrc: 'https://images.unsplash.com/photo-1534787238916-9ba6764efd4f?w=600&q=80',
    description: 'Maillots personalizados full print',
  },
];
